
const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const DeleteProduct = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_DELETE_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'PRODUCT_DELETE_ERROR':
            return { loading: false, error: true, data: [] };
        case 'PRODUCT_DELETE_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'PRODUCT_DELETE_RESET':
            return { loading: false, error: false, data: [] }; 
        default:
            return state;
    }
}

export default DeleteProduct